import { AlertTriangle, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface LocationDeniedCardProps {
  onOpenSettings: () => void;
  compact?: boolean;
  className?: string;
}

export function LocationDeniedCard({ 
  onOpenSettings, 
  compact = false,
  className 
}: LocationDeniedCardProps) {
  if (compact) {
    return (
      <div className={cn(
        "flex items-center gap-2 p-2 rounded-lg bg-destructive/10 text-destructive text-sm",
        className
      )}>
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className="flex-1">Location access denied</span>
        <Button 
          size="sm" 
          variant="ghost" 
          className="h-7 px-2 text-destructive hover:text-destructive"
          onClick={onOpenSettings}
        >
          <Settings className="h-3.5 w-3.5 mr-1" />
          Settings
        </Button>
      </div>
    );
  }

  return (
    <div className={cn(
      "flex flex-col items-center gap-4 p-6 rounded-xl border border-destructive/20 bg-destructive/5 text-center",
      className
    )}>
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
        <AlertTriangle className="h-6 w-6 text-destructive" />
      </div>
      
      <div className="space-y-2">
        <h3 className="font-semibold text-foreground">Location Access Denied</h3>
        <p className="text-sm text-muted-foreground max-w-xs">
          To check in at events and see nearby activities, please enable location access in your device settings.
        </p>
      </div>

      <Button onClick={onOpenSettings} variant="outline" className="gap-2">
        <Settings className="h-4 w-4" />
        Open Settings
      </Button>
      
      <p className="text-xs text-muted-foreground">
        Go to Settings → Privacy → Location Services → Enable for this app
      </p>
    </div>
  );
}
